import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/startChildcare/index'
import {Request} from 'pages/withAuth/adminPage/procedures/startChildcare/request'
import {StartChildcareFlow} from 'pages/withAuth/adminPage/procedures/startChildcare/flow'
import {Confirm} from 'pages/withAuth/adminPage/procedures/startChildcare/confirm'

export const StartChildcareRoutes: RouteParams[] = [
  {
    key: 'start_childcare',
    path: WITH_AUTH_ADMIN_PATHS.START_CHILDCARE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: 'start_childcare/request',
    path: WITH_AUTH_ADMIN_PATHS.START_CHILDCARE.REQUEST,
    component: Request,
    exact: true,
  },
  {
    key: 'start_childcare/flow/:id',
    path: WITH_AUTH_ADMIN_PATHS.START_CHILDCARE.FLOW,
    component: StartChildcareFlow,
    exact: true,
  },
  {
    key: 'start_childcare/confirm/:id',
    path: WITH_AUTH_ADMIN_PATHS.START_CHILDCARE.CONFIRM,
    component: Confirm,
    exact: true,
  },
]
